// src/components/property-pill-filters/property-pill-filters.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyPillSimilarSelectionOptionsTitleFragment on LodgingSimilarSelectionOptions {\n    title\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyFilterPillOptionLinkFragment on LodgingLinkMessage {\n    value\n    link {\n      clientSideAnalytics {\n        referrerId\n        linkName\n      }\n      referrerId\n      uri {\n        relativePath\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingSimilarSelectionOptionsFragment on LodgingSimilarSelectionOptions {\n    options {\n      ...PropertyFilterPillOptionLinkFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  query HSRFilterPillsQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $shoppingContext: ShoppingContextInput\n    $searchCriteria: PropertySearchCriteriaInput\n  ) {\n    propertyInfo(context: $context, propertyId: $propertyId, shoppingContext: $shoppingContext) {\n      id\n      similarProperties(searchCriteria: $searchCriteria) {\n        selectionOptions {\n          ...PropertyPillSimilarSelectionOptionsTitleFragment\n          ...LodgingSimilarSelectionOptionsFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
import React4 from "react";
import { gql as gql4, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
// src/components/property-pill-filters/__private/__fragments/property-pill-filters-title.tsx
import React from "react";
import { gql } from "@apollo/client";
import { EGDSHeading } from "@egds/react-core/text";
var __PropertyPillSimilarSelectionOptionsTitleFragment = gql(_templateObject());
var PropertyPillSimilarSelectionOptionsTitle = function(param) {
    var data = param.data;
    var title = data.title;
    return /* @__PURE__ */ React.createElement(EGDSHeading, {
        tag: "h3",
        size: 4
    }, title);
};
PropertyPillSimilarSelectionOptionsTitle.fragment = __PropertyPillSimilarSelectionOptionsTitleFragment;
PropertyPillSimilarSelectionOptionsTitle.displayName = "PropertyPillSimilarSelectionOptionsTitle";
// src/components/property-pill-filters/__private/__fragments/property-pill-selection-options.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSSpacing } from "@egds/react-core/spacing";
// src/components/property-pill-filters/__private/__fragments/property-pill-option-link.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSCard, EGDSCardContentSection, EGDSCardLink } from "@egds/react-core/cards";
import { EGDSIcon } from "@egds/react-core/icons";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSText } from "@egds/react-core/text";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
var __PropertyFilterPillOptionLinkFragment = gql2(_templateObject1());
var PropertyFilterPillOptionLink = function(param) {
    var _param_data = param.data, link = _param_data.link, value = _param_data.value, index = param.index;
    var clientSideAnalytics = link.clientSideAnalytics, uri = link.uri;
    var tracker = useClickTracker();
    var referrerId = React2.useMemo(function() {
        var _clientSideAnalytics;
        var rfrrId = ((_clientSideAnalytics = clientSideAnalytics) === null || _clientSideAnalytics === void 0 ? void 0 : _clientSideAnalytics.referrerId) || link.referrerId || "PWA.PDP.HSR_FILTER_OPTIONS";
        return "".concat(rfrrId, ".").concat(index, ".click");
    }, [
        link.referrerId,
        clientSideAnalytics,
        index
    ]);
    var onClick = React2.useCallback(function() {
        var _clientSideAnalytics;
        tracker(referrerId, ((_clientSideAnalytics = clientSideAnalytics) === null || _clientSideAnalytics === void 0 ? void 0 : _clientSideAnalytics.linkName) || "PDP HSR filter pill option");
    }, [
        tracker,
        referrerId,
        clientSideAnalytics
    ]);
    return /* @__PURE__ */ React2.createElement(EGDSCard, {
        "data-stid": "property-filter-pill",
        overflow: true
    }, /* @__PURE__ */ React2.createElement(EGDSCardContentSection, null, /* @__PURE__ */ React2.createElement(EGDSLayoutFlex, null, /* @__PURE__ */ React2.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */ React2.createElement(EGDSText, {
        theme: "emphasis",
        weight: "medium",
        size: 400
    }, value)), /* @__PURE__ */ React2.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */ React2.createElement(EGDSIcon, {
        name: "chevron_right"
    })))), /* @__PURE__ */ React2.createElement(EGDSCardLink, null, /* @__PURE__ */ React2.createElement("a", {
        href: uri.relativePath,
        onClickCapture: onClick
    }, value)));
};
PropertyFilterPillOptionLink.fragment = __PropertyFilterPillOptionLinkFragment;
PropertyFilterPillOptionLink.displayName = "PropertyFilterPillOptionLink";
// src/components/property-pill-filters/__private/__fragments/property-pill-selection-options.tsx
var __PropertyPillSimilarSelectionOptionsFragment = gql3(_templateObject2(), PropertyFilterPillOptionLink.fragment);
var PropertyPillSimilarSelectionOptions = function(param) {
    var data = param.data;
    var options = data.options;
    if (!options || !options.length) {
        return null;
    }
    return /* @__PURE__ */ React3.createElement(EGDSSpacing, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React3.createElement(EGDSLayoutFlex2, {
        space: "three",
        wrap: "wrap"
    }, /* @__PURE__ */ React3.createElement(React3.Fragment, null, options.map(function(filterOption, index) {
        return filterOption && /* @__PURE__ */ React3.createElement(EGDSLayoutFlexItem2, {
            key: "".concat(filterOption.value, "-").concat(index)
        }, /* @__PURE__ */ React3.createElement(PropertyFilterPillOptionLink, {
            index: index,
            data: filterOption
        }));
    }))));
};
PropertyPillSimilarSelectionOptions.fragment = __PropertyPillSimilarSelectionOptionsFragment;
PropertyPillSimilarSelectionOptions.displayName = "PropertyPillSimilarSelectionOptions";
// src/components/property-pill-filters/property-pill-filters.tsx
var __PropertyPillFiltersQuery = gql4(_templateObject3(), PropertyPillSimilarSelectionOptions.fragment, PropertyPillSimilarSelectionOptionsTitle.fragment);
var PropertyPillFilters = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr;
    var _data_propertyInfo_similarProperties;
    var context = useBexApi().context;
    var variables = _object_spread({
        context: context
    }, inputs);
    var _useQuery = useQuery(__PropertyPillFiltersQuery, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !data || !((_data_propertyInfo_similarProperties = data.propertyInfo.similarProperties) === null || _data_propertyInfo_similarProperties === void 0 ? void 0 : _data_propertyInfo_similarProperties.selectionOptions)) {
        return null;
    }
    return /* @__PURE__ */ React4.createElement("div", {
        className: "property-pill-filters"
    }, /* @__PURE__ */ React4.createElement(PropertyPillSimilarSelectionOptionsTitle, {
        data: data.propertyInfo.similarProperties.selectionOptions
    }), /* @__PURE__ */ React4.createElement(PropertyPillSimilarSelectionOptions, {
        data: data.propertyInfo.similarProperties.selectionOptions
    }));
};
PropertyPillFilters.displayName = "sharedui-PropertyPillFilters";
export { PropertyPillFilters };
//# sourceMappingURL=index.js.map